import React, { memo } from 'react';
import { PackageOpen } from 'lucide-react';

const EmptyState = memo(function EmptyState({
  icon: Icon = PackageOpen,
  title = 'No records found',
  description = 'There is no data available to display right now.',
  actionLabel,
  onAction,
  style = {},
  className = '',
}) {
  return (
    <div
      className={`empty-state-container ${className}`.trim()}
      style={{
        textAlign: 'center',
        padding: '48px 24px',
        background: '#FFFFFF',
        borderRadius: 14,
        border: '1.5px solid var(--border, #E5E7EB)',
        margin: '16px 0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: 'var(--cream, #FAF8F3)',
          color: 'var(--muted, #6B7280)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 16,
        }}
      >
        <Icon size={28} />
      </div>
      <h3
        style={{
          fontFamily: 'var(--font-serif, serif)',
          fontSize: 18,
          fontWeight: 700,
          color: 'var(--char, #1A1A1A)',
          marginBottom: 6,
        }}
      >
        {title}
      </h3>
      <p
        style={{
          fontSize: 13,
          color: 'var(--muted, #6B7280)',
          maxWidth: 400,
          margin: '0 auto 16px',
          lineHeight: 1.5,
        }}
      >
        {description}
      </p>
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="btn btn-pri btn-md"
          style={{
            background: 'var(--green, #1B5C3A)',
            color: '#FFFFFF',
            borderRadius: 9,
            padding: '9px 18px',
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
            border: 'none',
          }}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
});

export default EmptyState;
